import { render, staticRenderFns } from "./Change-Password.vue?vue&type=template&id=3ed24da6&"
import script from "./Change-Password.vue?vue&type=script&lang=js&"
export * from "./Change-Password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports